import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "locations",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "behaviour-locations" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
});
